import React from 'react';
import Card from './Card';
import Button from './Button';

const ChartCard = ({ title, data }) => {
  // Calculate chart dimensions and points
  const maxValue = Math.max(...data.map((d) => d.value));
  const minValue = Math.min(...data.map((d) => d.value));
  const range = maxValue - minValue || 1;
  const width = 100;
  const height = 60;
  const padding = 5;

  // Generate SVG path points
  const points = data.map((d, i) => {
    const x = (i / (data.length - 1)) * width;
    const y = height - ((d.value - minValue) / range) * (height - padding * 2) - padding;
    return `${x},${y}`;
  });

  const pathD = `M ${points.join(' L ')}`;

  // Create area fill path
  const areaD = `${pathD} L ${width},${height} L 0,${height} Z`;

  return (
    <Card>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-bold text-[var(--text-primary)]">{title}</h3>
          <Button variant="secondary" onClick={() => {}}>
            View Details
          </Button>
        </div>

        {/* Chart */}
        <div className="relative h-48 bg-surface-soft rounded-xl p-4">
          <svg
            viewBox={`0 0 ${width} ${height}`}
            className="w-full h-full"
            preserveAspectRatio="none"
          >
            {/* Grid lines */}
            {[0, 1, 2, 3, 4].map((i) => (
              <line
                key={i}
                x1="0"
                y1={(i * height) / 4}
                x2={width}
                y2={(i * height) / 4}
                stroke="#1F2937"
                strokeWidth="0.2"
              />
            ))}

            {/* Area fill */}
            <path
              d={areaD}
              fill="url(#goldGradient)"
              opacity="0.2"
            />

            {/* Line */}
            <path
              d={pathD}
              fill="none"
              stroke="url(#goldGradient)"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            {/* Gradient definition */}
            <defs>
              <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#22c55e" />
                <stop offset="93%" stopColor="#16a34a" />
              </linearGradient>
            </defs>
          </svg>

          {/* Stats overlay */}
          <div className="absolute top-4 left-4">
            <p className="text-xs text-[var(--text-primary)]">Current Value</p>
            <p className="text-2xl font-bold text-[var(--text-primary)]">
              ${data[data.length - 1]?.value.toLocaleString('en-US')}
            </p>
          </div>
        </div>

        {/* Legend */}
        <div className="flex items-center justify-between text-xs text-[var(--text-primary)]">
          <span>{data[0]?.label}</span>
          <span>{data[data.length - 1]?.label}</span>
        </div>
      </div>
    </Card>
  );
};

export default ChartCard;
